import { render } from "./classes-management.vue?vue&type=template&id=fb99d176&ts=true"
import script from "./classes-management.vue?vue&type=script&lang=ts"
export * from "./classes-management.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__